import LostSlothSvg from '../svg/LostSlothSvg';
import { Container } from './Hero.styles';

const LostHero = () => {
  return (
    <Container>
      <LostSlothSvg />
    </Container>
  );
};

export default LostHero;
